import { atom, selector } from "recoil";
import { AMEDAS_TYPE_AIR_TEMP } from "../components/map/layers/Amedas";
import { getCustomerSettings } from "../CustomerSettings";

export const amedasElementState = atom({
  key: 'amedasElementState',
  default: selector({
    key: 'amedasElement',
    get: () => {
      const element = getCustomerSettings("layerConfig.WX_ID_AMEDAS.defaultElement");
      return element ? element : AMEDAS_TYPE_AIR_TEMP;
    }
  })
});
